export default "__VITE_ASSET__Dn8T6jZ3__"